import { CommonGet, CommonPost } from "../../../../utils/CommonFetch";

export default {
    getOperationEntitiesByGroupForDropDown,
    getCollectionCategoryByOperationEntityForDropDown,
    getReportData
};

async function getOperationEntitiesByGroupForDropDown(id) {
    var operationEntityArray = [];
    var response = await CommonGet('/api/OperationEntity/GetAllFactoryFilteredOperationEntityByGroupID', 'groupID=' + id);
    for (let item of Object.entries(response.data)) {
        operationEntityArray[item[1]["operationEntityID"]] = item[1]["operationEntityName"];
    }
    return operationEntityArray;
}
async function getCollectionCategoryByOperationEntityForDropDown(factoryID) {
    const response = await CommonGet('/api/CollectionPoint/GetAllRouteByFactoryIDV2', 'factoryID=' + factoryID)
    let array = []
    for (let item of Object.entries(response.data)) {
        array[item[1]["collectionPointID"]] = item[1]["collectionPointName"]
    }
    return array;
}


//async function getCollectionCategoryByOperationEntityForDropDown(id) {
//    var collectionCategory = [];
//    var response = await CommonGet('/api/CollectionPoint/GetAllRouteByFactoryIDV2', 'factoryID=' + id);
//    for (let item of Object.entries(response.data)) {
//        if (item[1]["collectionPointCategoryID"] === 1)
//            collectionCategory[item[1]["collectionPointID"]] = item[1]["collectionPointName"];
//    }
//    return collectionCategory;
//} 

async function getReportData(data) {
    const response = await CommonPost('/api/BLSupplierWiseReport/GetDetailsForBLSupplierWiseReport', null, data);
    return response.data;
}


